import {
    SAVED_JOB_STATE_CHANGED_EVENT,
    type SavedJobStateChangedEvent,
    type SavedJobStateChangedSubscription,
} from './savedJobStateChangedEventTypes';

export {
    SAVED_JOB_STATE_CHANGED_EVENT,
} from './savedJobStateChangedEventTypes';
export type {
    SaveButtonSyncState,
    SavedJobStateChangedEvent,
    SavedJobStateChangedSource,
    SavedJobStateChangedSubscription,
} from './savedJobStateChangedEventTypes';

function isSavedJobStateChangedEvent(event: Event): event is CustomEvent<SavedJobStateChangedEvent> {
    const detail = (event as CustomEvent<Partial<SavedJobStateChangedEvent>>).detail;

    return (
        detail?.eventType === SAVED_JOB_STATE_CHANGED_EVENT &&
        typeof detail.jobKey === 'string' &&
        (detail.state === 'SAVED' || detail.state === 'VISITED') &&
        typeof detail.isSaved === 'boolean' &&
        (detail.source === 'viewjob' || detail.source === 'jobcard')
    );
}

export function dispatchSavedJobStateChanged(event: SavedJobStateChangedEvent): void {
    window.dispatchEvent(new CustomEvent(SAVED_JOB_STATE_CHANGED_EVENT, { detail: event }));
}

export function subscribeSavedJobStateChanged(
    handler: (event: SavedJobStateChangedEvent) => void,
): SavedJobStateChangedSubscription {
    const listener = (event: Event) => {
        if (isSavedJobStateChangedEvent(event)) {
            handler(event.detail);
        }
    };

    window.addEventListener(SAVED_JOB_STATE_CHANGED_EVENT, listener);

    return {
        remove: () => {
            window.removeEventListener(SAVED_JOB_STATE_CHANGED_EVENT, listener);
        },
    };
}
